import { SAVE_SELECTED_INSTITUTION_DATA } from 'stores/redux/actions/types';
import hOReducer from '../common/reducer';

const reducer = hOReducer(SAVE_SELECTED_INSTITUTION_DATA);
export default reducer;

